import { render, staticRenderFns } from "./Filezilla.vue?vue&type=template&id=5bd87e27&scoped=true&"
import script from "./Filezilla.vue?vue&type=script&lang=js&"
export * from "./Filezilla.vue?vue&type=script&lang=js&"
import style0 from "./Filezilla.vue?vue&type=style&index=0&id=5bd87e27&lang=scss&scoped=true&"
import style1 from "./Filezilla.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd87e27",
  null
  
)

export default component.exports